.spinner {
	display: inline-block;
	border: 2px solid color-mix(in srgb, currentcolor 25%, transparent);
	border-block-start-color: currentcolor;
	border-radius: var(--radius-full);
	animation: spin 0.6s linear infinite;

	&[data-size='small'] {
		inline-size: 1rem;
		block-size: 1rem;
	}

	&[data-size='medium'] {
		inline-size: 1.5rem;
		block-size: 1.5rem;
	}

	&[data-size='large'] {
		inline-size: 2.5rem;
		block-size: 2.5rem;
		border-width: 3px;
	}
}

@keyframes spin {
	to {
		transform: rotate(360deg);
	}
}

@media (prefers-reduced-motion: reduce) {
	.spinner {
		animation-duration: 1.5s;
	}
}
